import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../IndustryType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const OTA = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    const headerBg: string = '/images/backgrounds/ALEG-Image-OTA_Header.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit Tools for Online Travel Agencies</title>
                    <meta name='description' content='Traveler loyalty built into a single platform with unlimited applications.' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height industry-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <h1>
                                        Online Travel Agencies
                                    </h1>
                                    <p className=''>
                                        Traveler loyalty built into a single platform with unlimited applications.
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <div className='logo-wrapper' style={{ maxWidth: '350px' }}>
                                        <img src='/images/others/ALEG-Image-Header_DashText.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12 text-med' style={{ textAlign: 'center' }}>
                                    Keep your customers aware with proactive flight disruption notifications. Keep them happy with automation remediation. Keep them loyal by protecting their peace of mind. All while increasing your revenue.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        AirLegit&#169; for Online Travel Agencies
                                    </h3>
                                    <p className='no-margin'>
                                        Give your customers seamless, confident travel when they book with you. Offer AirLegit's value- added services bundled with your bookings and develop additional revenue streams with optional upgrades travelers appreciate.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-Body-OTA_1.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 small-screen-padding-top large-screen-padding-top'>
                                    <div className='bordered-img-wrapper left-img'>
                                        <img src='/images/others/ALEG-Image-Body-OTA_2.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 large-screen-padding-top'>
                                    <h3 className='text-med'>
                                        Online Travel Agency Use Case
                                    </h3>
                                    <p className='no-margin'>
                                        An Online Travel Agency incorporated FlightGuard48R into its booking flow to generate ancillary revenue while adding value to its customers. FlightGuard48R removes the uncertainty of modern travel by delivering flight awareness with consistent, meaningful flight status updates and remediation for changes and cancellations.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default OTA;